var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.017,
    height: 40,
    viewBox: "0 0 120.017 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-chrono",
    transform: "translate(-132.378 -320.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_696",
    "data-name": "Trac\\xE9 696",
    d: "M412.375,322.269l1.217-1.3c-3.353,0-6.867.14-10.5.433l-.625,1.5c3.423-.364,6.74-.57,9.9-.628",
    transform: "translate(-194.699 0)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M482.465,404.926a68.106,68.106,0,0,1-10.338,4.656l6.128,1.859a62.5,62.5,0,0,0,10.9-5.883Z",
    transform: "translate(-244.912 -60.521)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_698",
    "data-name": "Trac\\xE9 698",
    d: "M436.781,426.346c-2.606.816-5.362,1.563-8.24,2.224l4.073,3.228c3.458-.951,6.731-2,9.777-3.137Z",
    transform: "translate(-213.492 -75.962)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_699",
    "data-name": "Trac\\xE9 699",
    d: "M467.439,324.015l2.107-1.042a79.1,79.1,0,0,0-13.169-1.613l-1.451,1.217a67.735,67.735,0,0,1,12.513,1.438",
    transform: "translate(-232.512 -0.282)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_700",
    "data-name": "Trac\\xE9 700",
    d: "M526.1,370.724c-.927,2.469-3.311,4.98-6.83,7.36l6.583.291c3.2-2.725,5.115-5.538,5.437-8.267Z",
    transform: "translate(-278.899 -35.422)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_701",
    "data-name": "Trac\\xE9 701",
    d: "M517.2,333.894l3-.96a30.4,30.4,0,0,0-5.96-2.431l-2.362,1.009a22.769,22.769,0,0,1,5.319,2.382",
    transform: "translate(-273.569 -6.873)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_702",
    "data-name": "Trac\\xE9 702",
    d: "M544.434,349.679a8.55,8.55,0,0,0-3.477-5.212l-3.389.931a6.577,6.577,0,0,1,2.1,3.761,5.638,5.638,0,0,1,.042,1.26Z",
    transform: "translate(-292.086 -16.939)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_703",
    "data-name": "Trac\\xE9 703",
    d: "M145.284,370.158l-.089.43c-.335,1.6-.654,3.047-2.188,4.161-1.529,1.093-3.113,1.074-4.779,1.074-3.906,0-6.717-.2-5.6-5.548l.789-3.789c1.007-4.846,3.7-5.548,7.912-5.548,3.944,0,5.7.41,4.858,4.8l-.118.568h-3.943l.117-.568c.14-1.309-.741-1.4-2.042-1.4-2.182,0-2.535.683-2.971,2.773l-.476,2.286c-.454,2.188-.533,3.029,1.764,3.029,1.589,0,2.379-.118,2.737-1.837l.088-.43Z",
    transform: "translate(0 -28.812)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_704",
    "data-name": "Trac\\xE9 704",
    d: "M198.914,376.008h-3.828l1.2-5.744h-5l-1.194,5.744H186.26l3.049-14.651h3.829l-1.147,5.508h5l1.147-5.508h3.829Z",
    transform: "translate(-38.841 -29.114)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_705",
    "data-name": "Trac\\xE9 705",
    d: "M248,361.359h7.388c3.3.058,4.777.781,4.017,4.434-.508,2.442-.805,3.868-3.658,4.513l-.032.156a1.931,1.931,0,0,1,2.044,2.6l-.613,2.949h-3.829l.428-2.052c.264-1.093-.04-1.837-1.189-1.837h-2.968l-.808,3.889h-3.83Zm5.263,7.364c1.646,0,1.719-.625,2.063-2.285.272-1.31.025-1.681-1.238-1.681h-2.968l-.826,3.965Z",
    transform: "translate(-81.152 -29.116)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_706",
    "data-name": "Trac\\xE9 706",
    d: "M302.749,370.449l.862-4.141c.939-4.512,3.875-5.372,7.761-5.372s6.462.86,5.525,5.372l-.862,4.141c-.939,4.512-3.874,5.373-7.761,5.373s-6.464-.861-5.525-5.373m9.432-.43.687-3.3c.45-2.168-.213-2.383-2.2-2.383s-2.688.214-3.2,2.383l-.687,3.3c-.4,2.189.209,2.4,2.2,2.4s2.743-.215,3.2-2.4",
    transform: "translate(-122.674 -28.811)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_707",
    "data-name": "Trac\\xE9 707",
    d: "M362.337,376.008H358.51l3.048-14.651h6.471l1.773,11.252h.154l2.111-11.252H375.9l-3.048,14.651H366.32L364.6,364.756h-.154Z",
    transform: "translate(-163.009 -29.114)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_708",
    "data-name": "Trac\\xE9 708",
    d: "M424.873,370.449l.862-4.141c.939-4.512,3.875-5.372,7.76-5.372s6.465.86,5.526,5.372l-.86,4.141c-.94,4.512-3.876,5.373-7.763,5.373s-6.464-.861-5.525-5.373m9.434-.43.685-3.3c.451-2.168-.212-2.383-2.2-2.383s-2.686.214-3.194,2.383l-.689,3.3c-.4,2.189.208,2.4,2.2,2.4s2.745-.215,3.2-2.4",
    transform: "translate(-210.708 -28.811)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_709",
    "data-name": "Trac\\xE9 709",
    d: "M284.015,331.509a112.838,112.838,0,0,1,21.141-5.31c.328-.051.656-.1.983-.148l.229-1.592q-2.657.315-5.373.736a134.979,134.979,0,0,0-25.179,6.313Z",
    transform: "translate(-103.399 -2.516)",
    fill: "#00346e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M252.542,428.836q-2.212.426-4.5.782c-19.351,3.005-36.413,1.117-43-4.14H190.258c3.055,9.334,26.826,13.417,54.517,9.115,3.737-.58,7.361-1.285,10.835-2.094Z",
    transform: "translate(-41.723 -75.336)",
    fill: "#00346e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrono);
export default __webpack_public_path__ + "static/media/chrono.7cffbde9.svg";
export { ForwardRef as ReactComponent };